export default "__VITE_ASSET__CnBY3NvN__"